
import ResizeObserver from 'resize-observer-polyfill'

const install = (): void => {
	window.ResizeObserver = ResizeObserver
}
export default {
	install
}
